import useSWRMutation from 'swr/mutation';
import { DCreateComplaintMessage } from '../data/dtos/message';
import { complaintChatService } from '../services/complaint';

export function useCreateComplaintMessage({
  userId,
}: Pick<DCreateComplaintMessage, 'userId'>) {
  const execute = async (input: Omit<DCreateComplaintMessage, 'userId'>) => {
    return await complaintChatService.sendMessage({
      userId,
      ...input,
      content: input.content?.trimEnd() ?? null,
    });
  };

  const fetchKey = 'send-complaint-message';
  const { trigger, error, isMutating } = useSWRMutation(
    fetchKey,
    async (_, { arg }: { arg: Omit<DCreateComplaintMessage, 'userId'> }) =>
      await execute(arg)
  );

  return {
    trigger,
    error,
    isLoading: isMutating,
  };
}
